// 品牌相关
import fetch from '../utils/fetch';

// 畅销版商品
export function toplistCreate(data) {
  return fetch.post('/marketing/api/marketing/listHotCommodityTop', data);
}

// 获取畅销版页面的图片和背景色
export function hotbrandGet() {
  return fetch.get(`/commodity/api/commodityAdConfig/getForApp?type=COMMODITY_SALE_VOLUME`);
}

// 获取首页可授权品牌
export function hotbrandGetForApp() {
  return fetch.post(`/soyoungzg/api/zgBrand/listHotBrandForApp`);
}

// 查询畅销榜下单人数
export function hotBrandNumGet() {
  return fetch.post(`/marketing/api/statistics/queryBuyers`);
}

// 查询品牌详情
export function BrandDetailGet(id) {
  return fetch.get(`/commodity/api/brand/getForApp?id=${id}`);
}

// 根据品牌排序
export function brandListAllGroupByAcronym(data) {
  return fetch.post(`/commodity/api/brand/listAllGroupByAcronym`, data);
}

// 获取热门品牌
export function hotBrandListHotBrandForApp(data) {
  return fetch.post(`/commodity/api/hotBrand/listHotBrandForApp`, data);
}

// 获取商品广告配置
export function commodityAdConfigGetForApp(type) {
  return fetch.get(`/commodity/api/commodityAdConfig/getForApp?type=${type}`);
}

// 获取品牌管商品列表
export function BrandGoodsList(data) {
  // return fetch.post(`/marketing/api/marketing/listCommodityByBrandAndOrderBy`, data);
  // 20230322增加vip橱窗图配置更改
  return fetch.post(`/newretail/api/marketing/listCommodityByBrandAndOrderBy`, data);
}

// 获取权益兑换商品列表
export function BrandExchangeGoodsList(data) {
  return fetch.post(`/creditmall/api/goods/listGoodsByBrand`, data);
}
